import { OnInit } from '@angular/core';
import { SidebarNavService } from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import { TranslateService } from "@ngx-translate/core";
var AutomationAuditComponent = /** @class */ (function () {
    function AutomationAuditComponent(_translate, sidebarNavService) {
        this._translate = _translate;
        this.sidebarNavService = sidebarNavService;
        this.activeMenuId = 'workflow_instanceHistory';
        this.workflowData = undefined;
        this.dagRunId = undefined;
        this.currentActiveMenuItem = { id: "", status: undefined, title: "", visible: false };
    }
    AutomationAuditComponent.prototype.ngOnInit = function () {
        this.setSidebarMeta();
        this.sidebarNavService.setDefaultSelectedId(this.activeMenuId);
        this.sidebarNavService.setMetadata(this.sidebarMetadata);
    };
    AutomationAuditComponent.prototype.setSidebarMeta = function (stepsStatus) {
        if (stepsStatus === void 0) { stepsStatus = undefined; }
        this.sidebarMetadata = {
            showProgressBar: false,
            groups: [{
                    id: 'grp_history',
                    title: 'History'
                }],
            items: [
                {
                    id: 'workflow_instanceHistory',
                    title: this._translate.instant('Workflow history'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history',
                    selected: true,
                    iconClass: 'fa-solid fa-clock-rotate-left'
                },
                {
                    id: 'workflow_auditHistory',
                    title: this._translate.instant('Workflow audit'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history',
                    iconClass: 'fas fa-file-search'
                },
                {
                    id: 'workflow_audit2',
                    title: this._translate.instant('Workflow audit'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history2'
                },
            ]
        };
    };
    AutomationAuditComponent.prototype.setCurrentActiveItem = function (e) {
        this.currentActiveMenuItem = e;
    };
    return AutomationAuditComponent;
}());
export { AutomationAuditComponent };
